import ClayLayout from "@clayui/layout";
import { useEffect, useState } from "react";
import "../../index.scss";
import { getLearningPaths } from "../../services/learning-path";
import SectionCard from "../Common/SectionCard";
import { OBJECT_ENTRY_URL_SEPARATOR } from "../../utils/constants";

const LearningPathsList = () => {
	const [learningPaths, setLearningPaths] = useState(null);

	useEffect(() => {
		getLearningPaths(3)
			.then(data => setLearningPaths(data))
			.catch(error =>
				console.error('Error fetching learning paths:', error)
			);
	}, []);

	return (
		<ClayLayout.ContainerFluid view>
			<ClayLayout.Row justify="start">
				{learningPaths && learningPaths.length > 0 && (
					<>
						{learningPaths.map((learningPath, index) => {
							return (
								<SectionCard
									description={!learningPath.description ? '' : learningPath.description}
									expertise={learningPath.expertiseLevel.name}
									index={index}
									key={learningPath.id}
									link={`/${OBJECT_ENTRY_URL_SEPARATOR.LEARNING_PATH}/${learningPath.id}`}
									personas={learningPath.persona}
									title={!learningPath.title ? '' : learningPath.title}
								/>
							);
						})}
					</>
				)}
			</ClayLayout.Row>
		</ClayLayout.ContainerFluid>
	);
};

export default LearningPathsList;